import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-internal-navigator',
    templateUrl: './internal-navigator.component.html',
    styleUrls: ['./internal-navigator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterLink]
})
export class InternalNavigatorComponent implements OnInit {
    @Input()
    path?: string;

    @Input()
    label?: string;

    @Input()
    isActive?: boolean;

    normalizedPath?: string;

    constructor(private readonly router: Router) {}

    ngOnInit() {
        if (this.path) {
            this.normalizedPath = this.path.startsWith('/') ? this.path : `/${this.path}`;
        }
    }

    navigateTo() {
        this.router.navigate([this.path]);
    }

    handleAuxClick(event: MouseEvent) {
        if (event.button === 1 && this.path) {
            window.open(this.path, '_blank');
        }
    }
}
